<template>
  <div class="rule_content">
    <h3>具体退还规则:</h3>
    <p>
      1.退还申请须在首笔充值后2小时内完成，超时无效。计时将从您在本游戏的首笔订单支付开始，2小时内您可申请退还所有充值;
    </p>
    <p>
      例如:玩家A在10:00登录首发游戏，并在10:20进行了第一笔充值，那么玩家A可以在12:20之前，对10:20-12:20之间的充值申请退还，超过12:20将无法退还，游戏角色仍可继续游玩;
    </p>
    <p style="color:red;">
      2.退还支持充值余额和第三方支付线上的订单，<span style="color: #12cec7;">不支持各种赠送余额、优惠券、月卡券优惠支付订单，</span>退还类型为赠送余额，退还比例为50%，单款游戏最高退还额度为500余额(即游戏真实消费≥1000元，最高退还500赠送余额);
    </p>
    <p>3.退还时，将自动收回您在该游戏内有充值的小号，无法赎回，请谨慎操作;</p>
    <p>4.交易/回收/的小号，将无法申请退还;</p>
    <p>5.每个游戏仅允许使用一次退还功能，请谨慎使用;</p>
    <p>
      6.“安心玩”功能目前仅开放部分游戏，请注意游戏是否有【安心玩】标签，更多游戏开放敬请期待哦;
    </p>
  </div>
</template>
<style scoped>
.rule_content {
  padding: 0 32px;
  padding-top: calc(30px + constant(safe-area-inset-top));
  padding-top: calc(30px + env(safe-area-inset-top));
  width: 100%;
  height: 100vh;
  background-color: #f7f8fa;
}
.rule_content h3 {
  color: #333;
}
.rule_content p {
  margin-top: 40px;
  color: #333;
  font-size: 28px;
}
</style>
